import './styles/themes/index.css';
import './styles/markdown-content.css';
import './styles/article-layout.css';
import { checkBuildVersion } from '$lib/cacheManager.js';
import App from './App.svelte';
import { mount } from 'svelte';

// Clear stale caches before the app fetches any content
await checkBuildVersion();

const app = mount(App, {
  target: document.getElementById('app')!,
});

export default app;
